import type { ComponentProps, ElementType } from 'react'

import { cn } from '@/lib/utils'

interface ContainerProps extends ComponentProps<'div'> {
  as?: ElementType<ComponentProps<'div'>>
}

function Container({ as: Comp = 'div', className, ...props }: ContainerProps) {
  return (
    <Comp
      data-slot="container"
      className={cn('mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8', className)}
      {...props}
    />
  )
}

export { Container }
